<template>
  <b-tooltip :target="targetId">
    {{this.vectorName}}
    <table class="table table-sm color no-border">
      <tbody>
        <tr>
          <th class="text-left font-weight-normal">Period</th>
          <td v-for="(value, index) in this.vector.toString().split(',')" :key="index" class="text-right">{{index + 1}}</td>
        </tr>
        <tr>
          <th class="text-left font-weight-normal">{{this.vectorType}}</th>
          <td v-for="(value, index) in this.vector.toString().split(',')" :key="index" class="text-right">{{value}}</td>
        </tr>
      </tbody>
    </table>
  </b-tooltip>
</template>

<script>
export default {
  props: ["targetId", "vectorName", "vector", "vectorType"]
}
</script>

<style lang="scss">
.tooltip.show {
  opacity: 1;
}
.tooltip-inner {
  background-color: #f9f9f9;
  color: black;
  max-width: 40vw;
  overflow: auto;
}
.arrow {
  &:before {
    border-top-color: #f9f9f9;
  }
}
</style>


